import styled from 'styled-components';

import { media } from '@theme/mixins';
import colors from '@theme/colors';

export const Button = styled.button`
  appearance: none;
  font-size: 14px;
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  line-height: 64px;
  letter-spacing: normal;
  text-align: center;
  cursor: pointer;
  width: 100%;
  height: 64px;
  transition: 0.5s all;
  border: 1px solid transparent;
  background-color: ${({ dark, color }) =>
    color ? colors[color] : dark ? colors['very-light-brown'] : '#1b1b1b'};
  color: ${({ dark }) => (dark ? colors['black'] : colors['white'])};

  &:hover,
  &:active {
    background-color: ${({ hoverColor }) => hoverColor || colors['white']};
    color: ${({ dark }) => (dark ? colors['white'] : '#1b1b1b')};
    border-color: ${({ dark }) => (dark ? colors['white'] : colors['white'])};
  }

  &:disabled,
  &[disabled] {
    border: 1px solid ${colors['charcoal']};
    background-color: ${colors['charcoal']};
    color: ${colors['white']};
    cursor: not-allowed;
  }

  ${media.tabletPortraitUp`
    font-size: 16px;
    text-transform: none;
    letter-spacing: 0.125px;
  `};
`;
